/* Widths are centimetres, flat fabric only; no order is changed by this tool. */
(function () {
  function calculatePanels(rod, panel, fullness) {
    if (![rod,panel,fullness].every(Number.isFinite) || rod <= 0 || panel <= 0 || rod > 1000 || panel > 1000 || fullness < 1 || fullness > 3) return null;
    const count = Math.ceil(Math.round(rod * fullness / panel * 1e8) / 1e8);
    return { count, fabric: count * panel, coverage: count * panel / fullness };
  }
  if (typeof module !== 'undefined') module.exports = { calculatePanels };
  if (typeof document === 'undefined') return;
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-measure-form]');
    if (!form) return;
    event.preventDefault();
    const field = name => Number(new FormData(form).get(name));
    const result = calculatePanels(field('rod'), field('panel'), field('fullness'));
    const output = form.querySelector('[data-measure-result]');
    output.textContent = result ? `${result.count} panneau${result.count > 1 ? 'x' : ''} au minimum, soit ${result.fabric} cm de tissu à plat. Pour deux côtés symétriques, choisissez un nombre pair au moins égal à ce résultat. Vérifiez séparément la hauteur et la fixation.` : 'Indiquez des largeurs entre 1 et 1 000 cm et un coefficient de fronces entre 1 et 3.';
  });
})();
